module.exports = __webpack_public_path__ + "img/matic.adbc6ade.png";